/**
 * The timestamp a message should DISPLAY and SORT by: the externally-supplied
 * `external_created_at` (unix seconds, set by the Twilio→Chatwoot history backfill)
 * when present, otherwise the row's `created_at`. After useCamelCase(deep) the key is
 * `externalCreatedAt`; the snake_case fallback covers raw store / push-event objects.
 */
export const getMessageEffectiveTimestamp = message => {
  const attrs = message?.contentAttributes ?? {};
  return attrs.externalCreatedAt ?? attrs.external_created_at ?? message?.createdAt;
};

/**
 * Chronological comparator. Equal timestamps tie-break by id (insertion order), so a
 * normal conversation (no external timestamps) keeps its existing order exactly.
 */
export const compareMessagesByEffectiveTimestamp = (a, b) =>
  getMessageEffectiveTimestamp(a) - getMessageEffectiveTimestamp(b) ||
  (a?.id ?? 0) - (b?.id ?? 0);

/**
 * Whether a message carries an externally-supplied timestamp (set by the history
 * backfill). Gates the chronological re-sort so normal conversations stay untouched.
 * Reads the camelCase key first, then the snake_case fallback (matching
 * getMessageEffectiveTimestamp).
 */
export const hasExternalCreatedAt = message => {
  const attrs = message?.contentAttributes ?? {};
  return (attrs.externalCreatedAt ?? attrs.external_created_at) != null;
};
